import { Component, Input } from '@angular/core';
import { AbstractSections } from 'src/app/model/page/group/revision-notices/new-ndc-revision-notices-page';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-new-revision-notice-abstract-section',
  templateUrl: './new-revision-notice-abstract-section.component.html',
  styleUrls: ['./new-revision-notice-abstract-section.component.scss']
})
export class NewRevisionNoticeAbstractSectionComponent {
  @Input() sections: AbstractSections = {} as AbstractSections;
}
